export type PurchaseHistoryOrder = {
	orderTypeCode: string;
	totalShippingCharge: string;
	resourceId: string;
	orderId: string;
	lastUpdateDate: string;
	channel: Object;
	orderStatus: string;
	x_isPurchaseOrderNumberRequired: string;
	x_firstName: string;
	x_shipmentNumber: string;
	buyerId: string;
	grandTotalCurrency: string;
	buyerDistinguishedName: string;
	x_isPersonalAddressesAllowedForShipping: string;
	storeNameIdentifier: string;
	totalProductPriceCurrency: string;
	totalProductPrice: string;
	locked: string;
	totalAdjustmentCurrency: string;
	totalSalesTaxCurrency: string;
	totalSalesTax: string;
	grandTotal: string;
	storeUniqueID: string;
	shipAsComplete: string;
	x_trackingIds: string;
	totalShippingTax: string;
	prepareIndicator: string;
	totalShippingTaxCurrency: string;
	x_orderItems: string;
	x_lastName: string;
	totalAdjustment: string;
	placedDate: string;
};

const model: types.models.InputModel = {
	orderTypeCode: 'orderTypeCode',
	totalShippingCharge: 'totalShippingCharge',
	resourceId: 'resourceId',
	orderId: 'orderId',
	lastUpdateDate: 'lastUpdateDate',
	channel: 'channel',
	orderStatus: 'orderStatus',
	x_isPurchaseOrderNumberRequired: 'x_isPurchaseOrderNumberRequired',
	x_firstName: 'x_firstName',
	x_shipmentNumber: 'x_shipmentNumber',
	buyerId: 'buyerId',
	grandTotalCurrency: 'grandTotalCurrency',
	buyerDistinguishedName: 'buyerDistinguishedName',
	x_isPersonalAddressesAllowedForShipping: 'x_isPersonalAddressesAllowedForShipping',
	storeNameIdentifier: 'storeNameIdentifier',
	totalProductPriceCurrency: 'totalProductPriceCurrency',
	totalProductPrice: 'totalProductPrice',
	locked: 'locked',
	totalAdjustmentCurrency: 'totalAdjustmentCurrency',
	totalSalesTaxCurrency: 'totalSalesTaxCurrency',
	totalSalesTax: 'totalSalesTax',
	grandTotal: 'grandTotal',
	storeUniqueID: 'storeUniqueID',
	shipAsComplete: 'shipAsComplete',
	x_trackingIds: 'x_trackingIds',
	totalShippingTax: 'totalShippingTax',
	prepareIndicator: 'prepareIndicator',
	totalShippingTaxCurrency: 'totalShippingTaxCurrency',
	x_orderItems: 'x_orderItems',
	x_lastName: 'x_lastName',
	totalAdjustment: 'totalAdjustment',
	placedDate: 'placedDate',
};

export default model;
